export const translations = {
  fr: {
    common: {
      brandName: "The Charly Method",
      tagline: "Coaching & mentorat en leadership humain",
      freeBadge: "☕ Premier échange de 30 minutes offert",
      freeBadgeFull: "☕ Premier échange de 30 minutes offert • Sans aucun engagement",
      noCatch: "Sans engagement, sans pression",
      bookFreeChat: "Échange offert 30 min",
      bookFreeSession: "Réserver ma session offerte",
      bookFollowUpSession: "Réserver ma séance de suivi",
      letsTalk: "Échangeons sur votre situation",
      backToHome: "← Retour à l'accueil",
      viewJourney: "Découvrir le parcours",
      startConversation: "Démarrer un échange offert",
      exploreApproach: "Découvrir mon approche",
      confidentialNote: "Vos informations restent strictement confidentielles.",
      responseTime: "Je vous réponds personnellement sous 24 heures.",
      hourlyRate: "100 € / heure",
      currency: "€",
      rightsReserved: "Tous droits réservés.",
      footerNote: "Des échanges authentiques • Un mentorat ancré dans le réel"
    },
    nav: {
      home: "Accueil",
      about: "À propos",
      journey: "Parcours",
      services: "Services & tarifs",
      books: "Livres",
      resources: "Ressources",
      contact: "Contact",
      cta: "Échange offert 30 min"
    },
    hero: {
      badge: "☕ Premier échange de 30 minutes offert",
      badgeSub: "Sans engagement, sans pression",
      title: "Trouvons de la clarté dans vos grandes décisions.",
      subtitle: "Face à un choix de vie important ou en quête de repères dans votre rôle de manager ? Je vous propose un accompagnement direct, bienveillant et ancré dans le réel, pour vous aider à avancer en toute sérénité.",
      ctaPrimary: "Démarrer un échange offert",
      ctaSecondary: "Découvrir le parcours"
    },
    home: {
      pillarsBadge: "Accompagnement sur-mesure",
      pillarsTitle: "Comment je peux vous aider",
      pillarsSubtitle: "Pas de jargon théorique ni de recettes toutes faites. Trois approches concrètes adaptées à votre étape actuelle.",
      card1Title: "Choix de vie & carrière",
      card1Desc: "Un espace de parole bienveillant et sans jugement pour débloquer une décision délicate, dissiper vos doutes et aligner vos choix avec vos valeurs profondes.",
      card1Rate: "☕ 1er échange 30 min offert • Suivi 100 €/h",
      card1Link: "Découvrir l'accompagnement individuel",
      card2Title: "Mentorat managérial",
      card2Desc: "Un accompagnement pragmatique pour managers débutants ou confirmés. Apprenez à guider vos équipes avec clarté, authenticité et moins de stress.",
      card2Rate: "☕ 1er échange 30 min offert • Suivi 100 €/h",
      card2Link: "Découvrir le mentorat managérial",
      card3Title: "Cohésion d'équipe",
      card3Desc: "Aidez vos équipes à instaurer une communication sincère, désamorcer les non-dits et bâtir une confiance solide au quotidien.",
      card3Rate: "👥 Format sur-mesure • 100 €/h",
      card3Link: "Découvrir le soutien d'équipe",
      quoteBadge: "Philosophie",
      quoteText: "« Le coaching est avant tout une conversation sincère et exigeante entre deux êtres humains. »",
      coachCertifiedPill: "Certifié Université de Mons (UMONS)",
      coachIntro: "Coach certifié par l'Université de Mons (Coaching & Leadership Transformationnel) et fort de plus de 10 ans d'expérience en management opérationnel, je vous accompagne avec la méthode HUMAN : Écouter activement (Hear), Comprendre votre unicité (Understand), Donner du sens à vos choix (Meaning), Aligner avec empathie (Align) et Nourrir une croissance durable (Nurture).",
      btnAbout: "Mon parcours & ma méthode",
      btnJourney: "Voir les 4 étapes du parcours",
      stat1Number: "100%",
      stat1Label: "1er échange offert (30 min)",
      stat2Number: "10+ ans",
      stat2Label: "D'expérience terrain",
      stat3Number: "HUMAN™",
      stat3Label: "Approche éprouvée",
      stat4Number: "0",
      stat4Label: "Pression commerciale",
      ctaTitle: "Prêt à échanger sur ce qui vous préoccupe ?",
      ctaSubtitle: "Prenons un café virtuel. 30 minutes entièrement dédiées à vos questions, sans engagement et sans discours commercial.",
      ctaButton: "Réserver votre échange offert de 30 min"
    },
    about: {
      badge: "Expérience terrain & écoute",
      title: "À propos de moi & de mon approche",
      subtitle: "Le coaching est avant tout un partenariat de confiance. Voici mon parcours, ce qui m'anime et la manière dont nous travaillerons ensemble.",
      coachRole: "Coach certifié • Leadership transformationnel & carrière",
      certificationPill: "Certifié Université de Mons (UMONS)",
      experiencePill: "10+ ans de management & direction",
      personalQuote: "« Je suis convaincu que le coaching repose simplement sur un échange authentique et approfondi entre deux personnes. Vous ne trouverez aucun modèle standardisé ici. Mon rôle est de vous écouter pleinement, de partager mon expérience vécue du terrain et de vous guider pour trouver votre propre chemin. »",
      guaranteeTitle: "💬 L'engagement humain",
      guaranteeText: "Un accompagnement ne doit jamais être une formule rigide : il s'agit de votre parcours, de vos défis et de votre épanouissement. Voyons ensemble ce que nous pouvons accomplir.",
      ctaButton: "Échangeons sur votre situation actuelle",
      bio1: "Bonjour, je suis Charles Malec. Il nous arrive à tous d'arriver à un carrefour : devoir trancher une décision personnelle délicate ou chercher la prochaine étape de sa carrière. Dans ces moments-là, pouvoir échanger avec un interlocuteur neutre, bienveillant et expérimenté change tout.",
      bio2: "Mon coaching ne s'encombre ni de jargon d'entreprise ni de concepts théoriques abstraits. Il est ancré dans la vraie vie et le dialogue direct. Je vous aide à prendre du recul, à évaluer vos options et à poser des choix qui font véritablement sens pour vous.",
      bio3: "Ayant passé plus de dix ans à manager des équipes et à occuper des fonctions de direction, je connais intimement les réalités du quotidien professionnel. Je vous apporte des retours concrets et pragmatiques, nés de l'expérience du terrain et non de manuels scolaires.",
      bioCertification: "Pour allier cette expérience vécue aux exigences de déontologie les plus élevées, je suis diplômé du Certificat d'Université en Coaching et Leadership Transformationnel délivré par l'Université de Mons (UMONS). Cette certification universitaire reconnue valide scientifiquement ma posture d'écoute, mes outils méthodologiques et un cadre éthique rigoureux.",
      bio4: "Que vous cherchiez à démêler un dilemme personnel ou à diriger vos équipes avec davantage d'assurance et de sérénité, avançons ensemble, simplement d'humain à humain.",
      academicBadge: "Légitimité académique & Déontologie",
      academicTitle: "Certificat d'Université en Coaching et Leadership Transformationnel",
      academicInstitution: "Université de Mons (UMONS), Belgique",
      academicSummary: "Ce certificat universitaire certifie la maîtrise des approches scientifiques de la transformation humaine, de la psychologie du leadership et d'une éthique professionnelle rigoureuse.",
      academicPillar1Title: "Cadre déontologique strict",
      academicPillar1Desc: "Confidentialité absolue, absence totale de jugement et respect scrupuleux de l'autonomie et du rythme de chaque personne.",
      academicPillar2Title: "Méthodologies validées",
      academicPillar2Desc: "Approches éprouvées de la prise de recul, du décryptage des relations et de l'accompagnement des transitions délicates.",
      academicPillar3Title: "Double légitimité académique & terrain",
      academicPillar3Desc: "L'exigence d'un cursus universitaire certifié combinée à plus de dix ans d'expérience directe en management d'équipe.",
      academicProofNote: "📜 Attestation officielle et référentiel de compétences consultables sur demande."
    },
    human: {
      title: "L'approche HUMAN — Comment nous travaillons",
      h_title: "Écouter activement (Hear)",
      h_text: "Prendre le temps d'une véritable écoute. Dans la vie comme au travail, entendre ce qui se joue — y compris les non-dits — est le point de départ indispensable de toute clarté.",
      u_title: "Comprendre votre unicité (Understand)",
      u_text: "Chaque personne, chaque dynamique et chaque situation est singulière. Je m'adapte entièrement à votre contexte, à vos valeurs et à votre personnalité, sans calquer de grille toute faite.",
      m_title: "Donner du sens à vos choix (Meaning)",
      m_text: "Les décisions deviennent limpides lorsqu'elles sont alignées avec vos priorités profondes. Nous identifions ce qui compte vraiment pour vous afin de sécuriser des choix durables.",
      a_title: "Aligner avec empathie (Align)",
      a_text: "L'empathie permet de concilier vos aspirations personnelles et les réalités opérationnelles. Nous analysons vos options avec honnêteté, lucidité et bienveillance.",
      n_title: "Nourrir la croissance (Nurture)",
      n_text: "L'évolution personnelle et managériale est un travail continu. Nous mettons en place des habitudes claires et des actions réalistes pour ancrer vos progrès dans le temps."
    },
    journey: {
      badge: "Une démarche claire & transparente",
      title: "Votre parcours en 4 étapes",
      subtitle: "Un cheminement progressif, concret et rassurant, conçu pour vous apporter de la valeur dès notre premier échange.",
      stepNumber: "Étape",
      durationLabel: "Durée",
      costLabel: "Tarif",
      formatLabel: "Format",
      whatHappens: "Déroulement de l'étape",
      deliverables: "Ce que vous en retirez",
      prevStep: "← Étape précédente",
      nextStep: "Étape suivante →",
      ctaButton: "Démarrer par l'échange offert (30 min)",
      step1: {
        title: "1. Premier café virtuel",
        subtitle: "Découverte & clarification",
        badge: "100% offert • 30 min",
        description: "Un premier échange sans aucun engagement pour faire connaissance, poser vos questions à plat et vérifier si mon accompagnement correspond à vos attentes.",
        details: [
          "Échange 1-à-1 confidentiel en visioconférence (Google Meet)",
          "Analyse de vos enjeux actuels (choix de carrière, management, transition)",
          "Pistes de réflexion et premiers retours concrets sans obligation de suite"
        ],
        duration: "30 minutes",
        cost: "Offert (0 €)",
        format: "Visio 1-à-1"
      },
      step2: {
        title: "2. Cadrage personnalisé",
        subtitle: "Objectifs & feuille de route",
        badge: "Sur-mesure",
        description: "Si nous décidons d'avancer ensemble, nous définissons vos priorités, vos critères de réussite et un rythme adapté à vos disponibilités.",
        details: [
          "Clarification précise des résultats visés",
          "Définition de la fréquence des séances (bimensuelle ou mensuelle)",
          "Mise à disposition des premières grilles de réflexion et d'outils adaptés"
        ],
        duration: "Séance initiale",
        cost: "100 € / heure",
        format: "Feuille de route"
      },
      step3: {
        title: "3. Accompagnement pratique",
        subtitle: "Séances & cas concrets",
        badge: "Terrain & action",
        description: "Des séances régulières et interactives pour traiter vos situations réelles, débriefer vos actions et affiner votre posture au fil de l'eau.",
        details: [
          "Séances individuelles bimensuelles ou mensuelles (100 €/h)",
          "Échanges ponctuels par message entre les sessions en cas de besoin",
          "Exercices pratiques et mises en situation adaptés à vos défis"
        ],
        duration: "Flexible (1 à 6 mois)",
        cost: "100 € / heure",
        format: "Bimensuel / Mensuel"
      },
      step4: {
        title: "4. Autonomie durable",
        subtitle: "Ancrage & continuité",
        badge: "Impact pérenne",
        description: "Vous repartez avec une clarté totale, une confiance renforcée et des réflexes actionnables en toute autonomie dans votre quotidien.",
        details: [
          "Bilan complet des avancées et des déclics majeurs obtenus",
          "Accès continu aux ressources, lectures recommandées et modèles de management",
          "Possibilité de séances de suivi ponctuelles à la demande"
        ],
        duration: "Autonomie pérenne",
        cost: "Inclus",
        format: "Habitudes durables"
      }
    },
    services: {
      badge: "Accompagnements proposés",
      title: "Comment je peux vous accompagner",
      subtitle: "Pas de formules rigides. Uniquement des conseils honnêtes, concrets et adaptés à votre réalité.",
      service1Title: "Décisions de vie & de carrière",
      service1Desc: "Face à un choix délicat, un sentiment de blocage ou une envie de réorientation, posons les choses ensemble. Je vous offre un espace serein et confidentiel pour démêler vos pensées, explorer vos options et trouver la direction qui vous correspond.",
      service1Coffee: "☕ Prenons un café virtuel",
      service1FreeNote: "Les 30 premières minutes sont offertes. Sans aucun engagement.",
      service1Rate: "Séances de suivi : 100 € / heure",
      service2Title: "Mentorat managérial & leadership",
      service2Desc: "Prendre en main une équipe — en particulier lors d'une première prise de fonction — peut susciter des doutes. Ici, pas de cours magistral : nous partons de vos situations réelles pour vous aider à manager avec justesse, assurance et humanité.",
      service2Coffee: "☕ Prenons un café virtuel",
      service2FreeNote: "Les 30 premières minutes sont offertes. Sans aucun engagement.",
      service2Rate: "Séances de suivi : 100 € / heure",
      service3Title: "Accompagnement d'équipe",
      service3Desc: "Ayant piloté des équipes opérationnelles, je mesure combien l'équilibre entre performance et bienveillance humaine est subtil. J'aide vos équipes à fluidifier leur communication, lever les non-dits et renforcer la confiance mutuelle.",
      service3Header: "👥 Cohésion et alignement d'équipe",
      service3SubNote: "Format adapté à la taille de votre équipe et à vos enjeux.",
      service3Rate: "Séances : 100 € / heure",
      bookBtn: "Réserver ma session",
      bookTeamBtn: "Réserver une session",
      bannerTitle: "Vous hésitez sur la formule adaptée à votre situation ?",
      bannerDesc: "Nous ferons le point ensemble lors de votre premier échange offert de 30 minutes.",
      bannerBtn: "Planifier l'échange offert (30 min)"
    },
    books: {
      badge: "Lectures conseillées",
      title: "Livres recommandés",
      subtitle: "Une sélection d'ouvrages inspirants qui nourrissent le leadership humain, la dynamique d'équipe et la prise de décision authentique.",
      affiliateDisclaimer: "(En tant que Partenaire Amazon, nous réalisons un bénéfice sur les achats remplissant les conditions requises.)",
      buyAmazon: "Voir sur Amazon",
      descLabel: "Présentation",
      whyRecommendLabel: "Pourquoi je le recommande",
      book1Title: "The Human-Centric Workplace",
      book1Author: "Simone Fenton-Jarvis",
      book1Desc: "Explore comment la reconnaissance, le lien authentique et l'autonomie créent des environnements de travail épanouissants et durables.",
      book1Why: "Une approche très concrète pour réhumaniser le management, en plein accord avec notre philosophie.",
      book2Title: "Making Work Human",
      book2Author: "Eric Mosley & Derek Irvine",
      book2Desc: "Un guide pragmatique pour concevoir des entreprises qui placent le bien-être, la créativité et la considération au premier plan.",
      book2Why: "Des clés d'action directes pour les managers qui souhaitent diriger avec humanité sans renoncer à l'exigence.",
      book3Title: "The Heart of Service",
      book3Author: "Nick Glimsdahl",
      book3Desc: "Une réflexion captivante sur l'équilibre entre technologie, efficacité du service et authenticité de la relation humaine.",
      book3Why: "Idéal pour penser le management moderne à l'ère des outils numériques.",
      bannerTitle: "Besoin d'une recommandation personnalisée ?",
      bannerDesc: "Demandez-moi lors de votre échange offert de 30 min et je vous orienterai vers les meilleures lectures pour votre situation.",
      bannerBtn: "Demander une recommandation"
    },
    resources: {
      badge: "Bibliothèque The Charly Method",
      title: "Outils & ressources de leadership",
      subtitle: "Des fiches pratiques, des grilles d'évaluation et des vidéos inspirantes pour trouver de la clarté, progresser dans votre carrière et guider votre équipe. En libre accès gratuit.",
      backHome: "Retour à l'accueil",
      categories: "Catégories",
      tabToolbox: "Boîte à outils management",
      tabToolboxDesc: "Modèles et fiches opérationnelles pour animer vos entretiens et renforcer la confiance en équipe.",
      tabVideos: "Vidéos inspirantes",
      tabVideosDesc: "Sélection de conférences sur le leadership bienveillant, l'écoute active et la dynamique d'équipe.",
      tabCourses: "Modules & masterclass",
      tabCoursesDesc: "Vidéos pratiques pour développer votre posture d'écoute et vos réflexes de mentorat.",
      docTypePdf: "Modèle PDF",
      docTypeAssessment: "Grille d'évaluation",
      doc1Desc: "Un modèle structuré pour mener des entretiens individuels 1-à-1 constructifs et centrés sur la personne.",
      doc2Desc: "Une grille simple pour évaluer rapidement la dynamique et la santé humaine de votre équipe.",
      video1Desc: "Une analyse éclairante de Simon Sinek sur la manière dont les leaders créent un cercle de sécurité au sein des équipes.",
      video2Desc: "Découvrez avec William Ury comment l'écoute active permet de dénouer les désaccords profonds et de bâtir un vrai consensus.",
      course1Desc: "Un guide complet et pratique pour écouter activement, accueillir les réticences et accompagner avec empathie.",
      downloadTemplate: "Télécharger le document",
      watchYoutube: "Regarder sur YouTube",
      sidebarWidgetTitle: "💡 Besoin d'un accompagnement personnalisé ?",
      sidebarWidgetDesc: "Mettons ces outils en pratique dans votre contexte managérial ou de carrière. Échangeons ensemble.",
      sidebarWidgetBtn: "Prendre contact",
      noContent: "Aucun contenu disponible pour cette catégorie pour le moment."
    },
    contact: {
      badge: "Réservation en ligne Google Calendar",
      title: "Prendre rendez-vous ou m'écrire",
      subtitle: "Réservez directement votre créneau dans mon agenda ci-dessous, ou écrivez-moi un message si vous préférez partager votre contexte avant de fixer un échange.",
      card1Pill: "Nouveau client • 100% offert",
      card1Title: "1. Premier échange découverte",
      card1Duration: "30 minutes",
      card1Cost: "Offert (0 €)",
      card1Desc: "Un moment d'échange confidentiel et sans engagement pour faire le point sur vos défis actuels (choix de vie, posture managériale, transition de carrière). Sans aucun discours commercial.",
      card1Point1: "Visioconférence 1-à-1 sur Google Meet",
      card1Point2: "Confirmation immédiate et lien d'accès par e-mail",
      card1Point3: "Premières pistes de réflexion et découverte de la méthode HUMAN",
      card1BookBtn: "Réserver ma session offerte",
      card1ViewAgendaBtn: "Voir l'agenda ci-dessous ↓",
      card2Pill: "Clients réguliers",
      card2Title: "2. Séance de suivi & coaching",
      card2Duration: "60 minutes",
      card2Cost: "100 € / heure",
      card2Desc: "Vous êtes déjà engagé dans un accompagnement ? Réservez votre prochaine séance pour débriefer vos actions, traiter vos cas pratiques et maintenir votre élan.",
      card2Point1: "Bilan de vos expérimentations et de vos avancées",
      card2Point2: "Conseils ciblés en leadership et résolution de cas concrets",
      card2Point3: "Règlement habituel à l'issue de la séance",
      card2BookBtn: "Réserver ma séance de suivi",
      card2ViewAgendaBtn: "Voir l'agenda ci-dessous ↓",
      calendarHeaderTitle: "Agenda de réservation interactif",
      calendarHeaderDesc: "Choisissez la date et l'horaire qui vous conviennent le mieux",
      calendarTabFree: "Découverte offerte (30 min)",
      calendarTabFollowup: "Séance de suivi (1h)",
      calendarTabAll: "Tous les créneaux",
      calendarFooterSecurity: "Planning de rendez-vous Google Calendar • Lien Google Meet généré automatiquement",
      calendarFooterOpenNew: "Ouvrir dans Google Calendar",
      formBadge: "Vous préférez m'écrire en premier ?",
      formTitle: "Envoyer un message confidentiel",
      formSubtitle: "Si vous souhaitez présenter votre situation avant de fixer un rendez-vous, écrivez-moi directement. Je vous réponds personnellement sous 24h.",
      directEmailNote: "Vous pouvez également m'écrire directement par email à",
      directEmailAddr: "charles.malec@hotmail.fr",
      nameLabel: "Votre nom complet",
      namePlaceholder: "Ex. Thomas Martin",
      emailLabel: "Votre adresse e-mail",
      emailPlaceholder: "thomas@exemple.com",
      topicLabel: "Objet de votre message",
      topicOption1: "Choix de vie ou de carrière (1-à-1)",
      topicOption2: "Mentorat managérial & leadership",
      topicOption3: "Accompagnement d'équipe",
      topicOption4: "Question générale ou demande spécifique",
      messageLabel: "Votre message ou situation actuelle",
      messagePlaceholder: "Expliquez-moi en quelques lignes vos interrogations, la décision à laquelle vous faites face ou vos objectifs...",
      sendingBtn: "Envoi en cours...",
      submitBtn: "Envoyer mon message confidentiel",
      securityDisclaimer: "Strictement confidentiel. Aucun démarchage ni message promotionnel.",
      backHome: "← Retour à l'accueil"
    },
    thankyou: {
      title: "Merci pour votre message !",
      p1: "Votre message a bien été transmis — je vous remercie d'avoir pris le temps de partager votre situation.",
      p2: "Je réponds personnellement à chaque message dans un délai de 24 heures. En attendant, n'hésitez pas à explorer mon approche ou à me rejoindre sur LinkedIn.",
      aboutBtn: "Découvrir mon approche",
      linkedinBtn: "Me rejoindre sur LinkedIn"
    },
    footer: {
      tagline: "Coaching et mentorat en leadership humain pour vos choix de vie, de carrière et le management d'équipe. Des décisions guidées par la clarté, l'empathie et l'expérience du terrain.",
      freeBadge: "☕ Premier échange de 30 minutes offert",
      pagesTitle: "Navigation",
      getInTouchTitle: "Prendre contact",
      getInTouchDesc: "Prêt à échanger sur votre prochain défi personnel ou celui de votre équipe ?",
      bookBtn: "Échange offert 30 min",
      linkedinLink: "Me suivre sur LinkedIn →",
      copyright: "Tous droits réservés.",
      bottomNote: "Des échanges authentiques • Un mentorat ancré dans le réel"
    }
  },

  en: {
    common: {
      brandName: "The Charly Method",
      tagline: "Human-Centered Leadership Coaching & Mentoring",
      freeBadge: "☕ First 30-Minute Conversation Free",
      freeBadgeFull: "☕ First 30-Minute Conversation Free • No Catch, No Pressure",
      noCatch: "No catch, no pressure",
      bookFreeChat: "Free 30-min Chat",
      bookFreeSession: "Book Free Session",
      bookFollowUpSession: "Book Follow-up Session",
      letsTalk: "Let's Start a Conversation",
      backToHome: "← Back to Home",
      viewJourney: "Discover Your Journey",
      startConversation: "Start a Free Conversation",
      exploreApproach: "Explore My Approach",
      confidentialNote: "Your information remains strictly confidential.",
      responseTime: "I respond personally within 24 hours.",
      hourlyRate: "100€ / hour",
      currency: "€",
      rightsReserved: "All rights reserved.",
      footerNote: "Honest conversations • Real-world mentorship"
    },
    nav: {
      home: "Home",
      about: "About",
      journey: "Journey",
      services: "Services & Pricing",
      books: "Books",
      resources: "Resources",
      contact: "Contact",
      cta: "Free 30-min Chat"
    },
    hero: {
      badge: "☕ First 30-Minute Conversation Free",
      badgeSub: "No catch, no pressure",
      title: "Clear, Grounded Guidance When You Need It Most.",
      subtitle: "Navigating a major life transition, a tough career choice, or the daily challenges of managing a team? I offer direct, compassionate, and experienced coaching to help you find clarity and move forward with confidence.",
      ctaPrimary: "Start with a Free 30-Min Chat",
      ctaSecondary: "Discover Your Journey"
    },
    home: {
      pillarsBadge: "Tailored Mentorship",
      pillarsTitle: "How I Can Help You",
      pillarsSubtitle: "No rigid corporate frameworks or consultant buzzwords. Three practical approaches suited to your specific stage.",
      card1Title: "Life & Career Decisions",
      card1Desc: "A safe, confidential space to work through tough crossroads, evaluate your options, and find a direction that feels authentic and aligned with your values.",
      card1Rate: "☕ Free 30-min Discovery • 100€/h follow-up",
      card1Link: "Explore individual coaching",
      card2Title: "Management Mentoring",
      card2Desc: "Practical, real-world advice for new and experienced managers. Learn to lead your team with clarity, empathy, and less stress.",
      card2Rate: "☕ Free 30-min Discovery • 100€/h follow-up",
      card2Link: "Explore leadership mentoring",
      card3Title: "Team Alignment & Cohesion",
      card3Desc: "Help small teams build honest communication, clear misalignments, and cultivate genuine operational trust.",
      card3Rate: "👥 Tailored format • 100€/h",
      card3Link: "Explore team support",
      quoteBadge: "The Philosophy",
      quoteText: "“At its core, coaching is simply an honest, high-quality conversation between two human beings.”",
      coachCertifiedPill: "Certified by University of Mons (UMONS)",
      coachIntro: "Certified by the University of Mons in Coaching & Transformational Leadership, and backed by over 10 years of operational management experience, I guide you using the HUMAN approach: Hear actively, Understand uniqueness, find Meaning in choices, Align with empathy, and Nurture sustainable growth.",
      btnAbout: "My background & philosophy",
      btnJourney: "View the 4-step journey",
      stat1Number: "100%",
      stat1Label: "Free 1st Discovery (30 min)",
      stat2Number: "10+ Yrs",
      stat2Label: "Leadership Experience",
      stat3Number: "HUMAN™",
      stat3Label: "Methodology",
      stat4Number: "0",
      stat4Label: "Forced commitments",
      ctaTitle: "Ready to talk through what's on your mind?",
      ctaSubtitle: "Let's grab a virtual coffee. 30 minutes focused entirely on your questions, with zero sales pitch and zero pressure.",
      ctaButton: "Book Your Free 30-Min Discovery"
    },
    about: {
      badge: "Real-World Experience & Empathy",
      title: "About Me & My Approach",
      subtitle: "Coaching is a partnership built on trust. Here is who I am, what drives me, and how we will work together.",
      coachRole: "Certified Coach • Transformational Leadership & Career",
      certificationPill: "Certified by University of Mons (UMONS)",
      experiencePill: "10+ Years Management Experience",
      personalQuote: "“I believe that coaching is simply an honest, meaningful conversation between two people. You won't find generic templates here. My job is to listen deeply, share real-world experience, and help you find your own way forward.”",
      guaranteeTitle: "💬 The Human Commitment",
      guaranteeText: "Coaching should never feel like a pre-packaged corporate process. It is about your life, your career, and your growth. Let's see what is possible together.",
      ctaButton: "Let's discuss your current situation",
      bio1: "Hi, I'm Charles Malec. We all reach points where decisions feel heavy — whether it's navigating a personal transition or figuring out the next step in our career. Having an objective, supportive sounding board in those moments makes all the difference.",
      bio2: "My coaching doesn't rely on business jargon or rigid theoretical frameworks. It's grounded in real conversations. I help you step back, look at your situation with fresh perspective, and make choices that genuinely fit who you are.",
      bio3: "Having spent over a decade leading teams and working at senior levels, I understand the real pressures of management. I offer practical, down-to-earth insights gained from experience — not from textbooks.",
      bioCertification: "To anchor this real-world background in the highest professional and ethical standards, I earned the University Certificate in Coaching and Transformational Leadership from the University of Mons (UMONS). This accredited academic certification scientifically validates my active listening approach, methodological toolset, and strict ethical framework.",
      bio4: "Whether you need clarity on a specific decision or want to lead with more confidence, let's take that next step together, simply as one human to another.",
      academicBadge: "Academic Credential & Ethics",
      academicTitle: "University Certificate in Coaching and Transformational Leadership",
      academicInstitution: "University of Mons (UMONS), Belgium",
      academicSummary: "This university certificate validates mastery of scientific approaches to human transformation, leadership psychology, and exacting professional coaching ethics.",
      academicPillar1Title: "Strict Ethical Code",
      academicPillar1Desc: "Absolute confidentiality, non-judgment, and deep respect for individual autonomy and pace.",
      academicPillar2Title: "Evidence-Based Methodologies",
      academicPillar2Desc: "Proven tools for perspective-taking, relational dynamics, and steering complex personal or managerial transitions.",
      academicPillar3Title: "Dual Credibility: Academic & Real-World",
      academicPillar3Desc: "The rigor of an accredited university credential combined with over a decade of hands-on team and executive leadership.",
      academicProofNote: "📜 Official university certificate and competency syllabus available upon request."
    },
    human: {
      title: "The HUMAN Approach — How We Work",
      h_title: "Hear Actively",
      h_text: "We take the time to truly listen. In life and leadership, hearing what's really being said — and what isn't — is where real understanding begins.",
      u_title: "Understand Uniqueness",
      u_text: "No two individuals or dilemmas are the same. I focus on your specific context, values, and personality, rather than applying cookie-cutter frameworks.",
      m_title: "Meaning in Choices",
      m_text: "Decisions become clearer when they connect to what matters most to you. We uncover your core priorities so you can make choices you feel confident about.",
      a_title: "Align with Empathy",
      a_text: "Empathy bridges personal desires and practical realities. We evaluate your options with honesty, compassion, and common sense.",
      n_title: "Nurture Growth",
      n_text: "Growth is an ongoing practice. We develop sustainable habits and clear action steps that keep you moving forward after our sessions."
    },
    journey: {
      badge: "A Clear & Honest Process",
      title: "Your 4-Step Journey",
      subtitle: "A transparent, step-by-step roadmap designed to give you clarity and value from day one.",
      stepNumber: "Step",
      durationLabel: "Duration",
      costLabel: "Investment",
      formatLabel: "Format",
      whatHappens: "What happens during this step",
      deliverables: "What you take away",
      prevStep: "← Previous step",
      nextStep: "Next step →",
      ctaButton: "Start with a Free 30-Min Chat",
      step1: {
        title: "1. Virtual Coffee",
        subtitle: "Discovery & Fit",
        badge: "100% Free • 30 Min",
        description: "A free, zero-pressure conversation to get to know each other, discuss your situation, and see if my coaching fits what you need.",
        details: [
          "Confidential 1-on-1 video call on Google Meet",
          "Identify your main challenge (career, leadership, decision-making)",
          "Practical takeaway thoughts with no obligation to continue"
        ],
        duration: "30 Minutes",
        cost: "Free (0€)",
        format: "1-on-1 Video"
      },
      step2: {
        title: "2. Custom Alignment",
        subtitle: "Focus & Action Plan",
        badge: "Tailored",
        description: "If we decide to work together, we define your core goals, key milestones, and a cadence that fits your schedule.",
        details: [
          "Define specific, measurable outcomes for your sessions",
          "Agree on frequency (bi-weekly or monthly)",
          "Initial tools and frameworks tailored to your situation"
        ],
        duration: "Initial Session",
        cost: "100€ / hour",
        format: "Action Roadmap"
      },
      step3: {
        title: "3. Practical Coaching",
        subtitle: "Sessions & Real Cases",
        badge: "Action-Oriented",
        description: "Regular, focused sessions tackling your real-world situations, debriefing actions, and building confidence.",
        details: [
          "1-on-1 sessions held bi-weekly or monthly (100€/h)",
          "Light touchpoint support between meetings when needed",
          "Hands-on exercises and practical management tools"
        ],
        duration: "Flexible (1 to 6 months)",
        cost: "100€ / hour",
        format: "Bi-weekly / Monthly"
      },
      step4: {
        title: "4. Lasting Autonomy",
        subtitle: "Confidence & Continuity",
        badge: "Long-term Impact",
        description: "You walk away with renewed clarity, dependable frameworks, and the confidence to navigate future decisions on your own.",
        details: [
          "Review of key progress and breakthrough moments",
          "Ongoing access to recommended reading and templates",
          "Optional check-in sessions whenever you need a sounding board"
        ],
        duration: "Ongoing autonomy",
        cost: "Included",
        format: "Lasting habits"
      }
    },
    services: {
      badge: "Tailored Offerings",
      title: "How I Can Help You",
      subtitle: "No cookie-cutter packages. Just honest, practical guidance designed around where you are and what you need.",
      service1Title: "Life & Career Decisions",
      service1Desc: "When you are facing a tough decision, feeling stuck, or thinking about what comes next, let's talk. I offer a safe, confidential space to unpack your thoughts, weigh your options, and find a direction that feels right for you.",
      service1Coffee: "☕ Let's grab a coffee",
      service1FreeNote: "The first 30 minutes are completely on me. No pressure.",
      service1Rate: "Follow-up sessions: 100€ / hour",
      service2Title: "Management Mentoring",
      service2Desc: "Leading people — especially for the first time — can feel overwhelming. No corporate speak here: we work through your real, day-to-day situations so you can lead with confidence, clarity, and empathy.",
      service2Coffee: "☕ Let's grab a coffee",
      service2FreeNote: "The first 30 minutes are completely on me. No pressure.",
      service2Rate: "Follow-up sessions: 100€ / hour",
      service3Title: "Support for Teams",
      service3Desc: "Having run teams myself, I know how hard it is to balance getting results while keeping people happy. I help small teams build honest communication, resolve friction, and work better together.",
      service3Header: "👥 Practical team alignment",
      service3SubNote: "Customized to your team size and operational context.",
      service3Rate: "Sessions: 100€ / hour",
      bookBtn: "Schedule a Session",
      bookTeamBtn: "Schedule a Session",
      bannerTitle: "Not sure which format fits best?",
      bannerDesc: "We can figure it out together during your free 30-minute discovery chat.",
      bannerBtn: "Schedule Free 30-Min Chat"
    },
    books: {
      badge: "Curated Reading",
      title: "Recommended Books",
      subtitle: "Handpicked books that inspire human-centered leadership, authentic team dynamics, and clear decision-making.",
      affiliateDisclaimer: "(As an Amazon Associate, we earn from qualifying purchases.)",
      buyAmazon: "View on Amazon",
      descLabel: "Overview",
      whyRecommendLabel: "Why I recommend it",
      book1Title: "The Human-Centric Workplace",
      book1Author: "Simone Fenton-Jarvis",
      book1Desc: "Explores how recognition, connection, and empowerment drive human-centric workplaces, with strategies to foster sustainable performance and well-being.",
      book1Why: "Focuses on practical approaches to humanize workplaces, perfectly aligned with our approach.",
      book2Title: "Making Work Human",
      book2Author: "Eric Mosley & Derek Irvine",
      book2Desc: "A practical guide for creating workplaces that prioritize employee well-being, creativity, and performance over pure productivity metrics.",
      book2Why: "Directly aligns with human-centric principles, offering actionable insights for leaders.",
      book3Title: "The Heart of Service",
      book3Author: "Nick Glimsdahl",
      book3Desc: "A business parable for integrating technology in service while prioritizing human connection, with real-world leadership takeaways.",
      book3Why: "Balances technology and human-centricity, highly relevant for modern organizational life.",
      bannerTitle: "Looking for custom reading tailored to your situation?",
      bannerDesc: "Ask during your free 30-minute chat and I’ll provide tailored book suggestions.",
      bannerBtn: "Ask for Recommendations"
    },
    resources: {
      badge: "The Charly Method Library",
      title: "Coaching & Leadership Resources",
      subtitle: "Practical templates, courses, and inspirational videos to help you find clarity, grow in your career, and support your team. Completely free to access and download.",
      backHome: "Back to Home",
      categories: "Categories",
      tabToolbox: "Management ToolBox",
      tabToolboxDesc: "Actionable worksheets and templates designed to improve communication and build trust in your team.",
      tabVideos: "Inspirational Videos",
      tabVideosDesc: "Curated speeches and talks on leadership, human-centered coaching, and listening.",
      tabCourses: "Video Courses",
      tabCoursesDesc: "Guided masterclasses and courses to sharpen your day-to-day leadership and coaching skills.",
      docTypePdf: "PDF Template",
      docTypeAssessment: "Assessment Tool",
      doc1Desc: "A structured template for running highly effective, person-centered 1-to-1 meetings.",
      doc2Desc: "A simple scorecard to scan and assess team health across key human dimensions.",
      video1Desc: "A deep dive into how trust is built by creating a circle of safety within teams.",
      video2Desc: "Learn how active listening helps resolve deep conflicts and build genuine consensus.",
      course1Desc: "A comprehensive, practical guide to listening actively, handling resistance, and mentoring with empathy.",
      downloadTemplate: "Download Document",
      watchYoutube: "Watch on YouTube",
      sidebarWidgetTitle: "💡 Need customized support?",
      sidebarWidgetDesc: "Let's translate these tools into action for your specific career or team. Contact me to start a conversation.",
      sidebarWidgetBtn: "Get in touch",
      noContent: "No content available for this category yet."
    },
    contact: {
      badge: "Instant Google Calendar Booking",
      title: "Schedule a Session or Get in Touch",
      subtitle: "Book a dedicated time slot directly in my calendar below, or send a written note if you prefer to share your context first.",
      card1Pill: "First Time • 100% Free",
      card1Title: "1. First Discovery Meeting",
      card1Duration: "30 Minutes",
      card1Cost: "Free (0€)",
      card1Desc: "A dedicated, confidential space to discuss your challenges, career crossroads, or management goals. No catch and zero sales pitch.",
      card1Point1: "1-on-1 Google Meet video call",
      card1Point2: "Immediate calendar confirmation & reminder",
      card1Point3: "Explore fit with the HUMAN framework",
      card1BookBtn: "Book Free Session",
      card1ViewAgendaBtn: "View Agenda Below ↓",
      card2Pill: "Returning Clients",
      card2Title: "2. Coaching Follow-up",
      card2Duration: "60 Minutes",
      card2Cost: "100€ / hour",
      card2Desc: "Already started your coaching journey? Book your next session to review actions, work on practical cases, or keep your momentum.",
      card2Point1: "Debrief experiments & progress",
      card2Point2: "Hands-on leadership & management guidance",
      card2Point3: "Standard settlement after session",
      card2BookBtn: "Book Follow-up Session",
      card2ViewAgendaBtn: "View Agenda Below ↓",
      calendarHeaderTitle: "Interactive Booking Calendar",
      calendarHeaderDesc: "Select a date and time slot that fits your schedule",
      calendarTabFree: "Free Discovery (30m)",
      calendarTabFollowup: "Follow-up (100€)",
      calendarTabAll: "All Options",
      calendarFooterSecurity: "Google Calendar appointment scheduling • Automatic Google Meet link included",
      calendarFooterOpenNew: "Open in Google Calendar",
      formBadge: "Prefer to write first?",
      formTitle: "Send a Confidential Message",
      formSubtitle: "If you’d like to describe your specific situation before booking, write to me directly. I answer personally within 24 hours.",
      directEmailNote: "You can also write directly via email at",
      directEmailAddr: "charles.malec@hotmail.fr",
      nameLabel: "Your Name",
      namePlaceholder: "e.g. Alex Dupont",
      emailLabel: "Email Address",
      emailPlaceholder: "you@company.com",
      topicLabel: "What is this regarding?",
      topicOption1: "Life & Career Decision (1-on-1)",
      topicOption2: "Management & Leadership Mentoring",
      topicOption3: "Support for Teams",
      topicOption4: "General Question or Custom Request",
      messageLabel: "Your Message or Challenge",
      messagePlaceholder: "Tell me a bit about what is on your mind, what decision you are facing, or what you want to achieve...",
      sendingBtn: "Sending Message...",
      submitBtn: "Send Confidential Message",
      securityDisclaimer: "Strictly confidential. No spam or unwanted promotional emails.",
      backHome: "← Back to Home"
    },
    thankyou: {
      title: "Thank You for Reaching Out!",
      p1: "Your message has been received — and I truly appreciate you taking the time to share what is on your mind.",
      p2: "I respond personally to every message within 24 hours. In the meantime, feel free to explore more about my approach or connect with me on LinkedIn.",
      aboutBtn: "Learn More About My Approach",
      linkedinBtn: "Connect on LinkedIn"
    },
    footer: {
      tagline: "Human-centered coaching and mentorship for life, career decisions, and team leadership. Grounding choices in clarity, empathy, and real-world experience.",
      freeBadge: "☕ First 30-Minute Conversation Free",
      pagesTitle: "Pages",
      getInTouchTitle: "Get in Touch",
      getInTouchDesc: "Ready to talk through your next step or team challenge?",
      bookBtn: "Book Free Chat",
      linkedinLink: "Connect on LinkedIn →",
      copyright: "All rights reserved.",
      bottomNote: "Honest conversations • Real-world mentorship"
    }
  }
};
